import gql from 'graphql-tag';
import { List } from 'immutable';

import GraphQLClient from '../../adapter/GraphQLClient';
import YoutubeChannel from '../../entity/YoutubeChannel';
import { Creative } from '../../generated/graphql';
import { handleGoogleError } from './GoogleWebApi';

class YoutubeWebApi {
  private readonly graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public getAllConnectedChannels = async (): Promise<List<YoutubeChannel>> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          query getAllYoutubeChannels {
            youtubeChannels {
              channelId
              name
              thumbnailUrl
            }
          }
        `,
        {},
      );
      const items = result.youtubeChannels as YoutubeChannel[];
      return List(items);
    } catch (err) {
      handleGoogleError(err);
      throw err;
    }
  };

  public addConnectedChannel = async (authCode: string): Promise<YoutubeChannel> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation integrateYoutubeChannel($authCode: String!) {
            integrateYoutubeChannel(authCode: $authCode) {
              channelId
              name
              thumbnailUrl
            }
          }
        `,
        { authCode },
      );
      return result.integrateYoutubeChannel;
    } catch (err) {
      handleGoogleError(err);
      throw err;
    }
  };

  public revokeChannel = async (channelId: string): Promise<boolean> => {
    try {
      const result = await this.graphqlClient.query(
        gql`
          mutation revokeYoutubeChannel($channelId: ID!) {
            revokeYoutubeChannel(channelId: $channelId)
          }
        `,
        { channelId },
      );
      return result.revokeYoutubeChannel;
    } catch (err) {
      handleGoogleError(err);
      throw err;
    }
  };

  public sendCreativeToYoutube = async ({
    creative,
    youtubeChannel,
  }: {
    creative: Pick<Creative, 'id'>;
    youtubeChannel: YoutubeChannel;
  }) => {
    try {
      await this.graphqlClient.query(
        gql`
          mutation sendCreativeToYoutube($creativeId: ID!, $channelId: ID!) {
            sendCreativeToYoutube(creativeId: $creativeId, channelId: $channelId) {
              id
            }
          }
        `,
        {
          creativeId: creative.id,
          channelId: youtubeChannel.channelId,
        },
      );
      return;
    } catch (err) {
      handleGoogleError(err);
      throw err;
    }
  };
}

export default YoutubeWebApi;
